import React, { useState } from "react";
import axios from "axios";
import Modal from "../ui/Modal";
import InputText from "../ui/InputText";
import { BACKEND } from "../../config/configEnvs";
import {toast} from "react-toastify";
const NuevoLinkServicioDetailsDialog = ({
  open,
  onClose,
  title,
  idServicio,
  subarea,
  refetch
}) => {
  const [formValues, setFormValues] = useState({
    titulo: (subarea.toUpperCase() === "CMS" || subarea.toUpperCase() === "CODE") ? "Link Reunion" : "Archivo Informe",
    url: "",
  });

  const registerNewLink = async (e) => {
    e.preventDefault();
    await axios.post(`${BACKEND}/api/linksServicioCotizaciones`, {
      servicioCotizacion: idServicio,
      titulo: formValues.titulo,
      url: formValues.url,
    });

    onClose();
    toast.success("Registrado");
    refetch()
  };
  return (
    <Modal activeModal={open} onClose={onClose} title={title}>
    
      <form onSubmit={registerNewLink}>

         <InputText
          value={formValues.titulo}
          title={"Título"}
          required={true}
          setValue={(e) => setFormValues((prev) => ({ ...prev, titulo: e }))}
        />
        <InputText
          value={formValues.url}
          title={"URL"}
          required={true}
          setValue={(e) => setFormValues((prev) => ({ ...prev, url: e }))}
        />
        <div className=" my-6 flex justify-center">
          <button
            type="submit"
            className=" bg-[#FF6400] cursor-pointer hover:bg-orange-500 text-white p-2 rounded-md font-semibold "
          >
            Registrar
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default NuevoLinkServicioDetailsDialog;
